import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { DynamicOverlayService, OVERLAY_DATA } from 'src/app/shared/services/dynamic-overlay/dynamic-overlay.service';
import { StorageService } from 'src/app/storage.service';
import { ContentStateService } from 'src/app/views/content/content-state.service';
import { ChunkService } from '../../chunk.service';

const DEFAULT_TABLE_CONTENT = JSON.stringify({
  headers: ['Column 1', 'Column 2', 'Column 3'],
  rows: [
    ['', '', ''],
    ['', '', ''],
    ['', '', ''],
  ],
});

@Component({
  selector: 'app-add-table-option',
  standalone: true,
  imports: [TranslateModule, MatIconModule],
  template: `
    <div class="interactive-item" (click)="onClick()">
      <div class="interactive-item__content">
        <mat-icon class="interactive-item__icon" aria-hidden="true">table_chart</mat-icon>
        <span class="interactive-item__text">{{ 'CreateChunk.AddTable' | translate }}</span>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddTableOptionComponent {
  @Output() actionTriggered = new EventEmitter<void>();

  private overlay = inject(DynamicOverlayService);
  private chunkService = inject(ChunkService);
  private contentStateService = inject(ContentStateService);
  private storageService = inject(StorageService);
  private translate = inject(TranslateService);
  private data: { contentID: string; courseID?: string; blogID?: string; chunkAboveId?: string; chunkBelowId?: string } = inject(OVERLAY_DATA);

  async onClick(): Promise<void> {
    const { contentID, courseID, blogID, chunkAboveId, chunkBelowId } = this.data;

    const chunkParams = {
      contentID,
      courseID,
      blogID,
      type: 'table',
      content: DEFAULT_TABLE_CONTENT,
      language: this.translate.currentLang,
    };

    const serverResponse = await firstValueFrom(
      this.chunkService.createChunk({
        chunks: [chunkParams],
        insertBelowID: chunkAboveId,
        insertAboveID: chunkBelowId,
      })
    );

    const finalChunks = serverResponse.map((res: any) => ({ ...res.chunk, status: 'saved' }));
    await this.storageService.bulkStore('chunks', finalChunks);
    await this.contentStateService.getPieces(true);

    this.actionTriggered.emit();
    this.overlay.close();
  }
}
